export const GuidePageUpsellCardsMetaData = [
  {
    name: 'Idea',
    blpName: 'Halloween',
    imgUrl: 'https://i.pinimg.com/564x/64/57/66/645766dce0f2de6782e0660b5c8cf717.jpg',
    imgUrlBlp: 'https://i.pinimg.com/564x/64/57/66/645766dce0f2de6782e0660b5c8cf717.jpg',
    imgWidth: 224,
    imgHeight: 297,
    notShowInPinPage: true,
    link: '/pinterest_celebrations/halloween-ideas/',
  },
  {
    name: 'Party',
    blpName: 'Halloween Party',
    imgUrlBlp: 'https://i.pinimg.com/564x/fc/ad/fe/fcadfe96547600391dcbb2247d1f8f6f.jpg',
    imgUrl: 'https://i.pinimg.com/originals/d7/ee/cc/d7eecc197254cb8c3c33afa457c4ba5e.png',
    imgWidth: 224,
    imgHeight: 297,
    link: '/pinterest_celebrations/halloween-parties/',
  },
  {
    name: 'Costumes',
    blpName: 'Halloween Costumes',
    imgUrl: 'https://i.pinimg.com/originals/16/1c/85/161c852618d98ee1b351a6543c9bb98e.png',
    imgWidth: 224,
    imgHeight: 297,
    link: '/pinterest_celebrations/halloween-costumes/',
  },
  {
    name: 'Craft',
    blpName: 'Halloween Crafts',
    imgUrl: 'https://i.pinimg.com/originals/f1/a2/3e/f1a23ef674c885f7fb50f7f2178e6e84.png',
    imgWidth: 224,
    imgHeight: 297,
    link: '/pinterest_celebrations/halloween-crafts/',
  },
];

export const GuidePageAccountName = 'pinterest_celebrations';

export const GuidePageBoardName = [
  'halloween-crafts',
  'halloween-parties',
  'halloween-costumes',
  'halloween-ideas',
];

export const UnauthGuidePageMetaData = {
  '767300923952672844': {
    author: 'Pinterest Celebration',
    date: 'October 7, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: "10 Halloween Crafts You'll Want to Pin (and Make)",
    endText: [
      {
        type: 'string',
        value:
          "Feeling inspired? Start Pinning, then get crafting. And don't forget to Pin your Halloween creations on Pinterest.",
      },
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our 300 million strong community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: '11 Best Halloween Party Games, Treats, and More',
            url: '/pinterest_celebrations/halloween-parties/',
          },
          {
            type: 'link',
            text: 'Top 13 Halloween Ideas from Pinterest',
            url: '/pinterest_celebrations/halloween-ideas/',
          },
          {
            type: 'link',
            text: '13 Creative Halloween Costume Ideas for 2019',
            url: '/pinterest_celebrations/halloween-costumes/',
          },
        ],
      },
    ],
    subsections: [
      {
        sectionName: 'Halloween activities for kids',
        sectionPins: [
          {
            id: '382313455864531217',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "What brings these jack-o-lanterns to life? Paper cups, orange and black paint, green pipe cleaners and a popsicle sick for the stem, tea light candles for a nose that glows, and your little one's imagination.",
              },
            ],
          },
          {
            id: '560346378633547956',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Mummies, monsters, Dracula, Frankenstein, oh my! Bring your old toilet paper or paper towel rolls back from the dead and the possibilities for cute and creepy decorations will be endless. Just add paint and other details—like glitter and googly eyes—as desired.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween decor ideas',
        sectionPins: [
          {
            id: '93871973468284797',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "I see a thrilling time in your future, as you put together one of these masterful (yet deceptively easy) DIY crystal balls. How, you ask? Hint: This project involves pairing holiday ornaments with ornate vintage candle holders. It's time to dig out your Christmas decorations and hit up some local thrift stores to find the exact right base for your ball.",
              },
            ],
          },
          {
            id: '71846556532952226',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Mason jars and monsters never looked so cute. Cheers to your new adorable Halloween cocktail glasses or table decorations.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'DIY Halloween decorations for outside',
        sectionPins: [
          {
            id: '330451691408985894',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'All signs point to Halloween. And all signs also point to this being one of the top photo opps of your yard.',
              },
            ],
          },
          {
            id: '354517801914590560',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Our 2019 Halloween insights show that searches for Halloween garage decorations are up 71%. Get ready for some double, double, toil, and trouble to recreate this Halloween display. ',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween door ideas',
        sectionPins: [
          {
            id: '99431104263295744',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "The front door isn't just for knocking and for asking for Halloween treats. It's for making a—haunting, creepy, or supernatural—first impression. ",
              },
            ],
          },
          {
            id: '84583299236827796',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'There are Christmas wreaths, and even Thanksgiving ones. But what your door deserves this holiday is this eye-popping DIY Halloween wreath.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Cheap Halloween decorations',
        sectionPins: [
          {
            id: '16888567339993177',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'White sheets + masking tape = your DIY crime scene. It’s budget friendly and you can throw it all together minutes before your party guests arrive. Nobody has to know. It’ll be our little secret.',
              },
            ],
          },
          {
            id: '466685580134441147',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For another one-of-a-kind take on Halloween illumination, upcycle empty milk gallons into a string of ghoulish lights.',
              },
            ],
          },
        ],
      },
    ],
    introList: [
      {
        type: 'string',
        value:
          "It's that time of year. The spookiest. The craftiest. It's time for witches, ghosts, bats, pumpkins, and monsters. It's time for scissors, glue, markers, paint, and tape. It's time to decorate. To party. It's time for DIY and googly eyes. The creepier the better. The more budget-friendly the better. The more unique. The more grotesque. ",
      },
      {
        type: 'string',
        value:
          'The countdown to the big day—Halloween—is on. But you don’t need a lot of time, or money, to get your home, office, yard, or school looking like the scariest one around. All you need is a little creativity.',
      },
      {
        type: 'string',
        value:
          "You've come to the right place to get inspired. We've sifted through the best of Pinterest's tens of millions of boards filled with Halloween ideas, DIY Halloween props tutorials, and lists of cheap decorations you can make or buy. Here are some of our favorites: Halloween activities for kid, Halloween decor ideas, DIY Halloween decorations for outside, Halloween door ideas, Cheap Halloween decorations",
      },
      {
        type: 'string',
        value: "There's no time like the present to get started. Happy Halloween crafting!",
      },
    ],
  },
  '767300923952672104': {
    author: 'Pinterest Celebration',
    date: 'October 8, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '11 Best Halloween Party Games, Treats, and More',
    introList: [
      {
        type: 'string',
        value:
          "What's not to love about Halloween parties? The fun,games, treats, and screams. Plus, for the hosts, there's the fun of planning and, of course, Pinning.",
      },
      {
        type: 'string',
        value:
          'Thanks to the collective creativity of our 300 million strong community, there are tens of millions of Pinterest boards filled with Halloween DIY guides for everything from haunted houses to tombstone toss games. Here are some of our favorite Halloween party ideas: Halloween activities, Halloween food ideas, DIY Halloween props, Halloween decoration ideas',
      },
    ],
    subsections: [
      {
        sectionName: 'Halloween activities',
        endText: [
          {
            type: 'string',
            value:
              "For even more ideas, check out our guide to 10 Halloween Crafts You'll Want to Pin (and Make), filled with bewitchingly creative Halloween activities for kids.",
          },
        ],
        sectionPins: [
          {
            id: '484207397437150151',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Pin the bowtie on the skeleton. Pop goes the pumpkin. Halloween-themed piñatas. Guess what's inside the mystery bowls. This one's packed with Halloween activities for kids. Now the only question is which one(s) will you choose for your party?",
              },
            ],
          },
          {
            id: '351912457355126',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Everyone's a ghost for Halloween with this crowd pleaser. It's a race to find all of the candy corn hiding in the whipped cream—but there's a catch, none of the players can use their hands. ",
              },
            ],
          },
          {
            id: '824721750494990312',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For a morbid take on the classic lawn game cornhole, there\'s tombstone toss. Plus, discover tons of other do-it-yourself options, like the "eyeball dig" game (Hint: This one involves finding toy eyeballs hidden among cooked spaghetti). And what about prizes for the winners? There are step-by-step instructions for creating spooky skeleton trophies out of dollar-store finds.',
              },
            ],
          },
          {
            id: '786300416168164609',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Strike. Hole-in-one. Score. You've just won the party-planning lottery: 15 ideas for Halloween games for adults and kids. That's a win for you and your guests of all ages. Will you be as lucky when it's your turn to play?",
              },
            ],
          },
          {
            id: '525584219011401866',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Don't have the time or space for an elaborate game setup? How about Halloween Bingo? Print out these festive Bingo cards, substitute candy for Bingo tiles, and you and your guests will be good to go.",
              },
            ],
          },
          {
            id: '351912458930958',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For this simple game that can be set up in seconds, all you need are two Halloween favorites: glow sticks and pumpkins. Pair them together, and you have your own holiday-themed, carnival-style ring toss.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween food ideas',
        endText: [
          {
            type: 'string',
            value:
              "For even more ideas to Pin, check out Pinterest's Top 13 Halloween Ideas, a round-up of even more DIY guides for Halloween treats, Halloween cakes, and more.",
          },
        ],
        sectionPins: [
          {
            id: '704531935433089539',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For some sorcery in the kitchen, harness the power of Pinterest to transform Hershey's Kisses into witch hats, pretzel sticks and Reese's Peanut Butter Cups into witch brooms, and pretzel sticks into witch fingers. And that's just getting started on the list. Warning: These adorable finger foods may be just too cute to eat.",
              },
            ],
          },
          {
            id: '139470919695461387',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Of all the Halloween treats, this one truly takes the cake. For anyone planning a Halloween birthday party, make your special guest's wishes come true with this one-of-a-kind dish.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'DIY Halloween props',
        sectionPins: [
          {
            id: '605241637404214710',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Looking to scare up some fun with grown-up party guests? Haunted houses are trending this year, with searches up 267%, according to our 2019 holiday insights. Some Halloween party ideas for adults from this guide include: Staging a skeleton behind a decorated bar cart, Using a black light to illuminate creepy glow-in-the dark Halloween sayings, Hanging spooky Halloween pictures, Draping your walls with coverings and spider webs',
              },
            ],
          },
          {
            id: '446841594279860856',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Get the scoop on how to make your house look like it's straight out of a horror movie—complete with your own DIY murder scene, dead bodies, bloody candles, and more. Bonus points for pulling off these Harry Potter-inspired floating candles and assembling your own haunted mirrors.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween decoration ideas',
        sectionPins: [
          {
            id: '77264949842794924',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "This year 72% of Halloween shoppers plan to buy decorations, according to the National Retail Federation. But you don't have to spend a lot to surprise and delight and even startle and shock your party guests. Head to your nearest discount store then add your own personal spin on these party table settings, favors, and more.",
              },
            ],
          },
        ],
      },
    ],
    endText: [
      {
        type: 'string',
        value:
          "The countdown to the big day is on, so happy Pinning—and Halloween party planning! As you get going, don't forget to Pin your own Halloween party ideas on Pinterest.",
      },
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our 300 million strong community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: "10 Halloween Crafts You'll Want to Pin (and Make)",
            url: '/pinterest_celebrations/halloween-crafts/',
          },
          {
            type: 'link',
            text: 'Top 13 Halloween Ideas from Pinterest',
            url: '/pinterest_celebrations/halloween-ideas/',
          },
          {
            type: 'link',
            text: '13 Creative Halloween Costume Ideas for 2019',
            url: '/pinterest_celebrations/halloween-costumes/',
          },
        ],
      },
    ],
  },
  '767300923952672102': {
    author: 'Pinterest Celebration',
    date: 'October 8, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: '13 Creative Halloween Costume Ideas for 2019',
    introList: [
      {
        type: 'string',
        value:
          'It’s Halloween costume planning season. Time to celebrate what makes you unique. Your clever side. Your cool side. Your funny side. ',
      },
      {
        type: 'string',
        value:
          'Dressing up solo, with your best friend, a college group, the office, your whole family, as part of a duo or trio, while looking for easy Halloween costumes? Here are our top 13 favorite creative Halloween costume ideas for 2019.',
      },
    ],
    subsections: [
      {
        sectionName: 'DIY Halloween costumes',
        sectionPins: [
          {
            id: '158470480625678381',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Fruit Loops aren't your thing? Make this costume your own by substituting in your favorite brand. Use cookies for Cookie Crisp, brown balls for Reese's Puffs—the possibilities are endless.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'College Halloween costumes',
        sectionPins: [
          {
            id: '151715081184191824',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'This one\'s perfect for a group of friends from college or the office because everyone gets a say in just how spicy their individual costume will be. For a variation on the same "food group" theme, consider these related homemade Halloween costumes: spices Halloween group costume, candy bar Halloween group costume, and condiments Halloween group costume. ',
              },
            ],
          },
          {
            id: '51087777003174871',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Peace, love, groovy, far out. Harness your inner hippie flower child. Bonus points if you make your own tie-dye shirt and arrange your own DIY daisy chain crown. Get together with one friend, and you have a duo Halloween costume. Add another, and you have a trio. This idea can work for groups of any size.',
              },
            ],
          },
        ],
      },
      {
        sectionName:
          'Duo Halloween costumes, couple Halloween costumes, and best friend Halloween costumes',
        sectionPins: [
          {
            id: '415316396883922656',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Which is your favorite Scooby Doo duo? Grab your best friend or better half and pick a pair of characters from the hit show to dress up as. Daphne and Velma are trending this year, with searches for the two up 274% according to our insights. You can easily turn this duo costume into a group one and get the whole gang together.',
              },
            ],
          },
          {
            id: '824721750494922141',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Edgy. Dangerous. Wanted by the FBI. Live life on the wild side dressed up with your favorite partner in crime as Bonnie and Clyde—one of the most iconic villainous couples from history.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Teacher Halloween costumes',
        sectionPins: [
          {
            id: '201817627036961474',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Get the staff together and dress up as a box of Crayons—or take that one step further, and go all out as a set of school supplies. For other solo or group costume ideas for teachers, you can't go wrong with bringing your favorite storybook characters to life. The teachers who inspired this guide dressed up as the mouse from If You Give a Mouse a Cookie, The Grouchy Ladybug, and more.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Family Halloween costume ideas',
        sectionPins: [
          {
            id: '737042295244373155',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'The baby from The Hangover may be growing up, but if your little one still fits in a baby carrier, you can dress up as Alan and baby Carlos from the movie. Some other family ideas from this guide? The cast of Willy Wonka, a sushi meal, your favorite Toy Story characters, and more.',
              },
            ],
          },
          {
            id: '496310821431772404',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Superhero costumes are always a popular choice for people (and pets) of all ages. For families who want to dress up together, you can go as characters from Guardians of the Galaxy, as pictured here, or The Incredibles, The Avengers, Black Panther, Wonder Woman and more.',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Baby Halloween costume ideas',
        sectionPins: [
          {
            id: '824721750495006702',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "It's a hotdog, a gumball machine, a gnome, a slice of pizza. It's 22 creative ways to dress up the baby of the family—before they start having an opinion about what they want to be for Halloween. If your little one will be in a baby carrier, consider turning these ideas into a duo costume for the two of you. For instance, if your baby dresses up as a slice of pizza, you can go as a chef.",
              },
            ],
          },
          {
            id: '158470480625796757',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For your little one who's just starting to walk, here's a great option to give them a push to practice their skills with a stroll around the block during Halloween trick-or-treating. Plus, 99 other costume ideas for young ones of all ages.",
              },
            ],
          },
          {
            id: '790452172074955766',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'What goes together better than peanut butter and jelly? Your little ones dressed up in this easy-to-make DIY PB&J ensemble, of course. If you go out on Halloween, be prepared to have lots of people asking to take pictures with your family. ',
              },
            ],
          },
        ],
      },
      {
        sectionName: "Kids' Halloween costume ideas",
        sectionPins: [
          {
            id: '708120741386992958',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "For fans of Coco, dress your child up as the star, Miguel, or turn it into a family group costume, with everyone choosing different characters from the movie. To recreate Miguel's Day of the Dead-inspired look, you'll need Halloween makeup, a sweatshirt, jeans, boots, and his signature guitar.",
              },
            ],
          },
          {
            id: '123989795976300499',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Looking for something a little different than the traditional Halloween classics for kids? Among all the witches, ghosts, vampires, and pirates out trick-or-treating, your child can stand out dressed as a scuba diver, peacock, snail, bowl of Easy Mac, or any one of these 23 unique suggestions. ',
              },
            ],
          },
        ],
      },
    ],
    endText: [
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: "10 Halloween Crafts You'll Want to Pin (and Make)",
            url: '/pinterest_celebrations/halloween-crafts/',
          },
          {
            type: 'link',
            text: 'Top 13 Halloween Ideas from Pinterest',
            url: '/pinterest_celebrations/halloween-ideas/',
          },
          {
            type: 'link',
            text: '11 Best Halloween Party Games, Treats, and More',
            url: '/pinterest_celebrations/halloween-parties/',
          },
        ],
      },
    ],
  },
  '767300923952672100': {
    author: 'Pinterest Celebration',
    date: 'October 8, 2019',
    avatar: 'https://i.pinimg.com/280x280_RS/a8/ef/98/a8ef985655a5b4b2b5d1dbb7b47dfc9c.jpg',
    title: 'Top 13 Halloween Ideas from Pinterest',
    introList: [
      {
        type: 'string',
        value:
          'On Halloween anyone can be an artist. In the kitchen—whipping up creepy and cute Halloween treats. Transforming every inch of the house, yard, front door, driveway, and garage with DIY Halloween props and spooky decor. Using pumpkin carving skills to craft next-level funny, cool, cute, and scary jack-o’-lantern faces. ',
      },
      {
        type: 'string',
        value:
          "It's no wonder the holiday inspires Pinterest's community members to get planning and Pinning at this time of year. In fact, there are already tens of millions of boards packed with Halloween ideas for everything from recipes for mummy dog appetizers to step-by-step instructions for how to make melting bloody hand candles.",
      },
      {
        type: 'string',
        value:
          "How do you narrow down all of that creativity into one ultimate list of the top 13 Halloween ideas? It's a daunting task. But we managed to do it. Here are our favorites.",
      },
    ],
    subsections: [
      {
        sectionName: 'Halloween food ideas, treats, recipes and cakes',
        sectionPins: [
          {
            id: '294000681920965831',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Store-bought candy has nothing on these whimsical, monstrous, and fantastic homemade Halloween treats—with options for every taste, such as cupcakes, puddings, cookies, brownies, and more. It won't all be sugar and spice. There is the daunting challenge of choosing which recipes to make.",
              },
            ],
          },
          {
            id: '267471665356273888',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Finger foods, how about frightening foods? You know what goes well with mummy dogs? Jalapeño popper mummies, one of the most-saved Halloween foods on Pinterest last year. ',
              },
            ],
          },
          {
            id: '744993963335951359',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'This is one brain food that may be too perfectly grotesque to eat. Be sure to stick a knife in the dessert to create a truly terrifying look. Take pictures of your final product, then let your guests eat their hearts—or the brain cake—out.',
              },
            ],
          },
          {
            id: '61150507441302396',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "It's what's on the inside that counts. Cut into this elegant black and orange cake to reveal a colorful candy corn core. Note: Behind the scenes work will include creating six separate cake layers, three black and three white cake layers—with one remaining white and the others colored yellow and orange to achieve the candy corn surprise shape inside. If you like cake reveals, pumpkin piñata cakes are also a thing. When you cut inside these cakes, Halloween candies spill out instead of pumpkin seeds.",
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Halloween DIY',
        sectionPins: [
          {
            id: '629448485400077951',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Haunted houses are trending on Pinterest this year. With an eye for detail and a knack for putting together unnerving, hair-raising decor—such as these hanging cages pictured here, you too can transform your home into a scary scene this Halloween.',
              },
            ],
          },
          {
            id: '545920786072585361',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'DIY spider web balls—horrifying, or the perfect addition to your Halloween yard decorations? This guide has tons of other ideas for outdoors and indoors, including Halloween door themes, floating witch hat displays, and more.',
              },
            ],
          },
          {
            id: '642537071814547611',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Needed: Mason jar(s), fake eyeballs, and a red food coloring and water concoction (or a red drink). And, voilà, you have one or many DIY Halloween props perfect for creeping out your Halloween party guests.',
              },
            ],
          },
          {
            id: '315463148898685311',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'Contrasts between light and dark and night and day have long been a part of Halloween celebrations throughout time, dating back to the ancient origins of the holiday thousands of years ago. To this day, fires and candles remain part of our rituals. In modern times, however, we have more types of illumination than ever to choose from—such as this bleeding hand candle.',
              },
            ],
          },
          {
            id: '412149803400295690',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'It\'s the little things that can make a big difference. Even small spaces, such as apartments or entry-ways, can take on a new life at Halloween. Turn your bookcases into "boo" cases, by covering the whole thing from top to bottom in ghosts, spider webs, bats, and more. ',
              },
            ],
          },
          {
            id: '741123682411919093',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "From the front door to the fridge door, from the table centerpiece to the walls, the possibilities for places and ways to decorate for Halloween are endless. Ready for your next DIY project to tackle? This cute, classic jack-o'-lantern craft is one of 25 to keep you busy until October 31st, 2019 (and maybe even until October 31, 2020). ",
              },
            ],
          },
          {
            id: '626844841867725133',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'For a modern take on the classic Halloween decorations of skeletons and spiders, consider recreating this humorous backyard scene. Or take things a step further by reversing the roles—with extra-large spiders taking miniature skeletons on a walk. ',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Pumpkin carving ideas',
        sectionPins: [
          {
            id: '439945457350365977',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  'You can read the pure terror in this poor pumpkin’s eyes as a group of cannibal mini-pumpkins attempt to eat it to pieces. Now, how to recreate this one-of-a-kind pumpkin carving idea and make it your own?',
              },
            ],
          },
          {
            id: '560416747381963393',
            guidePageDescription: [
              {
                type: 'string',
                value:
                  "Who knew that adding string to jack-o'-lantern faces could have such a chilling effect? Also scary? Opting for a design with one eye, no eyes, super small eyes, and oversized eyes. For those searching for fun or cute pumpkin carving ideas, this guide also includes an It's the Great Pumpkin, Charlie Brown scene, as well as pumpkin carving examples inspired by The Wizard of Oz and Disney.",
              },
            ],
          },
        ],
      },
    ],
    endText: [
      {
        type: 'string',
        value:
          'Happy Halloween—however you ultimately choose to celebrate the holiday and your own creativity! As you get started, be sure to Pin your Halloween recipes, DIY decorations, pumpkin carving tips, and more to share with the Pinterest community.',
      },
      {
        type: 'string',
        value:
          'For more ways to celebrate, check out our other Halloween guides, curated from the tens of millions of holiday-themed Pinterest boards created by our community:',
      },
      {
        type: 'list',
        value: [
          {
            type: 'link',
            text: "10 Halloween Crafts You'll Want to Pin (and Make)",
            url: '/pinterest_celebrations/halloween-crafts/',
          },
          {
            type: 'link',
            text: '13 Creative Halloween Costume Ideas for 2019',
            url: '/pinterest_celebrations/halloween-costumes/',
          },
          {
            type: 'link',
            text: '11 Best Halloween Party Games, Treats, and More',
            url: '/pinterest_celebrations/halloween-parties/',
          },
        ],
      },
    ],
  },
};
